import { SpinnerSize } from './../../../../../shared/common/shared.enums';
import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Category } from 'src/app/core/data/model';
import { LookUpsRepository } from 'src/app/core/data/repository';
import { TreeDropDownCallBack } from 'src/app/shared/bloc/tree-dropdown-bloc';
import { BaseFilterComponent } from 'src/app/shared/component/base-filter-component/base-filter-component';
import { DateRangeComponent, DateRanges } from 'src/app/shared/component/date-range/date-range.component';
import { TreeDropdownComponent } from 'src/app/shared/component/tree-dropdown/tree-dropdown.component';
import { DropdownConfigurations, StatisticsFilterForm } from 'src/app/shared/interfaces';
import { CheckObjectValuesPipe } from 'src/app/shared/pipes/check-object-has-value.pipe';
import { StatisticsPDFBloc } from '../../bloc/pdf-bloc';
import { InitEvent } from 'src/app/shared/bloc/base-bloc';
import { SpinnerComponent } from 'src/app/shared/component/spinner/spinner.component';

@Component({
  selector: 'app-dashboard-filters',
  standalone: true,
  imports: [
    CommonModule,
    DateRangeComponent,
    TreeDropdownComponent,
    ReactiveFormsModule,
    MatIconModule,
    CheckObjectValuesPipe,
    TranslateModule,
    SpinnerComponent,
  ],
  templateUrl: './dashboard-filters.component.html',
  styleUrls: ['./dashboard-filters.component.scss'],
})
export class DashboardFiltersComponent extends BaseFilterComponent<StatisticsFilterForm> implements OnInit {
  categoriesDropdownConfigs: DropdownConfigurations;
  resetFilterValue: object = { date: { start: new Date(), end: new Date(), range: DateRanges.TODAY } };
  isPdfReady: boolean = false;
  isExportingPdfInProgress: boolean;

  //enums
  SpinnerSize = SpinnerSize;

  constructor(injector: Injector, private pdfBloc: StatisticsPDFBloc) {
    super([], injector);
  }

  // hooks
  override ngOnInit(): void {
    super.ngOnInit();
    this.setCategoriesDropDownConfigs();
    this.checkIsPdfReady();
    this.checkIsPdfExportingIsReady();
  }

  // publics
  fetchCategories(): TreeDropDownCallBack<Category[]> {
    return (page: number, limit: number) => this.injector.get(LookUpsRepository).getCategories(page, limit);
  }

  onExportPdf(): void {
    this.pdfBloc.setEvent.next(new InitEvent());
  }

  // overrides
  protected override initializeForm(): void {
    const initalStartDate = new Date(new Date().setHours(0, 0, 0, 0));
    const initialEndDate = new Date(new Date().setHours(23, 59, 59, 999));

    this.form = new FormGroup({
      date: new FormControl({
        value: { start: initalStartDate, end: initialEndDate, range: DateRanges.TODAY },
        disabled: false,
      }),
      categories: new FormControl(),
    });
  }

  // privates
  private setCategoriesDropDownConfigs(): void {
    this.categoriesDropdownConfigs = {
      isMultipleSelect: false,
      placeholder: 'CATEGORY',
      treeFormControlName: 'categories',
    };
  }

  private checkIsPdfReady(): void {
    this.pdfBloc.pdfReady$.subscribe((value) => {
      this.isPdfReady = value.statisticsCommentsReady && value.statisticsGenderReady && value.statisticsReady;
      // value.statisticsMapReady &&
      // &&
      // value.statisticsScoreboardReady;
    });
  }
  private checkIsPdfExportingIsReady(): void {
    this.pdfBloc.exportPdfInProgress.subscribe((value) => {
      this.isExportingPdfInProgress = value;
      console.warn(this.isExportingPdfInProgress);
    });
  }
}
